/// <reference types="vite/client" />
//resolve a public/ asset path against Vite's base URL. Assets loaded at runtime by string
//(png/mp3/woff passed to loaders) aren't rewritten by Vite the way import()ed ones are, so a
//bare "/background.png" stays absolute and 404s under a subfolder deploy. Prepending
//import.meta.env.BASE_URL ("/" in dev, "./" in the built app) makes them resolve correctly in both.
export const asset = (path: string): string =>
    import.meta.env.BASE_URL.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
